import axios from "axios";
import apiURL from "../apiURL";


interface IGetMarketerID {
    token: string;
    marketerID: string;
}

const baseURL = apiURL();

const GetMarketerNewID = async (props: IGetMarketerID): Promise<string> => {
    try {
        const token = props.token;
        const response = await axios.get<string>(
            `${baseURL}Marketer/getMarketerNewID?marketerID=${props.marketerID}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        // Handle the error here
        console.error('Error checking for duplicates:', error);
        throw error;
    }
};

export default GetMarketerNewID;